export default __webpack_public_path__ + "static/media/not-logged-in.banner.288260d8.png";